module.exports = __webpack_public_path__ + "img/link-03.204450d8.png";